/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import OrderFieldSvg from "assets/icons/svg/orderFields";
import ParametereValuesSvg from "assets/icons/svg/parametereValues";
import PointerSvgComponent from "assets/icons/svg/pointer";
import ResultsSvgComponent from "assets/icons/svg/results";
import { SubHeader } from "layout/SubHeader";
import InfoTooltip from "components/InfoTooltip";
import MyButton from "components/MyButton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import NotAuthorized from "../../../components/NotAuthorized";
import { filterState, reset } from "./filterSlice";
import "./index.scss";
import OrderFields from "./orderFields";
import ParameterValue from "./parameterValue";
import SearchResult from "./result";

const CreateNewFilter = () => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const getFilterState = useSelector((state) => state.filterParams.search);
  const [search, setSearch] = useState("search");
  const [isReportActive, setIsReportActive] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const [getPreviousVal, setGetPreviosuVal] = useState(true)

  const pageTitle = location?.state?.isRunSegment
    ? "Run Segment"
    : id
    ? "Edit Segment"
    : "Create Segment";

  let goTo = localStorage.getItem("goto");
  useEffect(() => {
    setSearch(goTo);
  }, [goTo]);

  const renderTabContent = () => {
    switch (search) {
      case "parameter":
        return <ParameterValue getPreviousVal={getPreviousVal} onClick={() => setSearch("order")} id={id} />;
      case "order":
        return (
          <OrderFields
            onClick={() => setSearch("results")}
            goToParameter={() => setSearch("parameter")}
            id={id}
          />
        );
      case "results":
        return <SearchResult goToOrder={() => { setSearch("order"); setGetPreviosuVal(false) }} id={id} />;
      default:
        return;
    }
  };
  useEffect(() => {
    dispatch(filterState(search));
  }, [dispatch, search]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "report") {
        return setIsReportActive(item?.active);
      }
    });
  }, []);
  return isReportActive === false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="create-filter">
      <div>
        <SubHeader
          className="subheader"
          {...{
            color: "#000",
            title: pageTitle,
          }}
        />
      </div>
      <div className="filter-details">
        <div className="header">
          <div>
            <div className={"selected-svg"}>
              <ParametereValuesSvg className="check-svg" />{" "}
              <PointerSvgComponent
                className="arrow-pointer"
                lineFill={"#99b7ef"}
                arrowFill={"#2655ef"}
              />
            </div>
            <div className="selected-parameter-text" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              1. Filter
              <InfoTooltip text="Pick the criteria members must match to be included in this segment, e.g. account status, tags, or location." style={{ marginLeft: '6px' }} />
            </div>
          </div>
          <div>
            <div
              className={
                search === "order"
                  ? "selected-svg"
                  : search === "results"
                    ? "selected-svg"
                    : "svg-size"
              }
            >
              <OrderFieldSvg className="check-svg" />
              <PointerSvgComponent
                className="arrow-pointer"
                lineFill={
                  search === "order" || search === "results"
                    ? "#99b7ef"
                    : "#e7e7eb"
                }
                arrowFill={
                  search === "order" || search === "results"
                    ? "#2655ef"
                    : "#b5b5c3"
                }
              />
            </div>
            <div
              className={
                search === "order"
                  ? "selected-parameter-text"
                  : search === "results"
                    ? "selected-parameter-text"
                    : "parameter-text"
              }
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              2. Add Fields
              <InfoTooltip text="Choose which fields to show for the matching members and set the order they appear in." style={{ marginLeft: '6px' }} />
            </div>
          </div>
          <div>
            <div className={search === "results" ? "selected-svg" : "svg-size"}>
              <ResultsSvgComponent className="check-svg" />
            </div>
            <div
              className={
                search === "results"
                  ? "selected-parameter-text"
                  : "parameter-text"
              }
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              3. Results
              <InfoTooltip text="View the matching contacts, then save this segment or export/print the results." style={{ marginLeft: '6px' }} />
            </div>
          </div>
        </div>
        {/* <div className="divider">
          <hr />
        </div> */}
        <div style={{ position: "relative" }}>
          <div className="filter-container">{renderTabContent()}</div>
          {search !== "results" && (
            <MyButton
              content="Cancel"
              type="secondary"
              style={{ position: "absolute", bottom: "25px", left: "25px", height: "40px", minHeight: "40px" }}
              onClick={() => push("/report")}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateNewFilter;
